module.exports = __webpack_public_path__ + "img/IMG_0691.7525aba2.jpg";